import angular from 'angular';
import Navbar from './navbar/navbar';
import InfoWidget from './info-widget/info-widget';
import ErrorWidget from './error-widget/error-widget';
import PageNavigation from './page-navigation/page-navigation';
import ModelView from './model-view/model-view';
import FileUpload from './file-upload/file-upload';
import MenuElements from './services/menu-elements';
import LoadedModel from './services/loaded-model';
import NextFocus from './services/set-thickness-directive';
import RadioControl from './radio-control/radio-control';
import SelectControl from './select-control/select-control';
import SolverProgress from './solver-progress/solver-progress';
import SnapshotWidget from './snapshot-widget/snapshot-widget';
import SessionNotification from './session-notification/session-notification';
import CaptchaWithFallback from './captcha-with-fallback/captcha-with-fallback';

import './common.styl';


let commonModule = angular.module('app.common', [
  Navbar,
  InfoWidget,
  ErrorWidget,
  PageNavigation,
  ModelView,
  FileUpload,
  LoadedModel,
  NextFocus,
  MenuElements,
  RadioControl,
  SelectControl,
  SolverProgress,
  SnapshotWidget,
  SessionNotification,
  CaptchaWithFallback,
])

  .name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js